import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { RecommendationKey, RecommendationType } from '../../typings/recommendations';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { HoverTooltipWrapper } from '../HoverTooltipWrapper/HoverTooltipWrapper';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';

import './RecommendationsGridItemAllowCell.css';
import * as keyset from './RecommendationsGridItemAllowCell.i18n';

const i18n = i18nFactory(keyset);

export interface RecommendationsGridItemAllowCellProps {
    name: string;
    id: string;
    isInProgress: boolean;
    isApplicable: boolean;
    recommendationType: RecommendationType;
    recommendationKeys: Array<RecommendationKey>;
    onSubmit: (type: RecommendationType, keys: Array<RecommendationKey>, id: string, name: string) => void;
}

export class RecommendationsGridItemAllowCell extends React.PureComponent<RecommendationsGridItemAllowCellProps> {
    render() {
        const { isInProgress, isApplicable } = this.props;

        return (
            <div className="recommendations-grid-item-allow-cell">
                <ButtonDecorator
                    onClick={this.onSubmitButtonClick}
                    view="classic"
                    theme="action"
                    size="n"
                    progress={isInProgress}
                    disabled={!isApplicable}
                    text={this.getButtonTextByType()}
                />
                {this.getButtonHint()}
            </div>
        );
    }

    private getButtonTextByType = (): string => {
        const { recommendationType, isInProgress } = this.props;
        const texts = {
            [RecommendationType.removePagesFromBlackList]: i18n('platform-accept-button'),
            [RecommendationType.switchOnAutotargeting]: i18n('switch-on-autotargeting-button')
        };
        const progressTexts = {
            [RecommendationType.removePagesFromBlackList]: i18n('platform-accept-progress-button'),
            [RecommendationType.switchOnAutotargeting]: i18n('switch-on-autotargeting-progress-button')
        };

        const text = isInProgress ? progressTexts[recommendationType] : texts[recommendationType];

        if (!text) {
            throw new Error(
                `Тип рекомендации ${recommendationType} не поддерживается для формирования текста кнопки применения рекомендации`
            );
        }

        return text;
    };

    private getButtonHint = () => {
        const { isApplicable } = this.props;

        if (isApplicable) {
            return null;
        }

        return (
            <HoverTooltipWrapper
                tooltipText={i18n('no-rights')}
                to={['top', 'left']}
                isDoccenterTooltip={false}
                cls={Bem.cls('recommendations-grid-item-allow-cell', 'hint')}
            >
                <Shape2 width={16} height={16} icon={Shape2Icon.warning} />
            </HoverTooltipWrapper>
        );
    };

    private onSubmitButtonClick = () => {
        const { name, onSubmit, recommendationKeys, id, recommendationType } = this.props;

        onSubmit(recommendationType, recommendationKeys, id, name);
    };
}
